import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const SET_FACILITIES = "SET_FACILITIES";

export interface SetFacilitiesType {
  type: string;
  facilities: racehorse360.IFacility[];
}

export const setFacilities = (
  facilities: racehorse360.IFacility[]
): SetFacilitiesType => {
  return {
    type: SET_FACILITIES,
    facilities
  };
};
